import React from "react";
import { QR_CODE_ITEMS } from "../../constants/qrcodes";
import QrcodeCard from "./QrcodeCard";
import ScrollReveal, { revealItemProps } from "../common/Reveal";

function QrcodeGrid({ compact = false }) {
  return (
    <ScrollReveal
      stagger
      className={`mx-auto grid w-full max-w-5xl grid-cols-1 gap-6 px-4 sm:grid-cols-2 lg:grid-cols-3 ${
        compact ? "pb-0 pt-1" : "py-4"
      }`}
    >
      {QR_CODE_ITEMS.map((item, index) => (
        <div key={item.id} {...revealItemProps(index, "min-w-0")}>
          <QrcodeCard {...item} />
        </div>
      ))}
    </ScrollReveal>
  );
}

QrcodeGrid.revealManaged = true;

export default QrcodeGrid;
